import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = React.useRef(false);

  React.useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        const dest = window.location.pathname.startsWith("/admin") ? "/admin/analytics" : "/portal";
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate(dest, { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-secondary tracking-widest uppercase text-xs">Signing you in…</div>
    </div>
  );
}
